export default "__VITE_ASSET__aeb19aeb__"